import React from 'react';
import PropTypes from 'prop-types';
import RegisterLoginButtons from '../RegisterLoginButtons';
import DropPanelDesktop from '../../DropPanelDesktop';
import LoginForm from '../../LoginForm';
import NoSSR from '../../NoSSR';

const HeaderSkeleton = ({ auth, userAgent, openDropPanel, toggleMenu, activeDropPanel, closeDropPanel }) => {
  return (
    <div className="header-skeleton">
      <div className="header-skeleton__container">
        <div className="header-skeleton__logo" />
        <div className="header-skeleton__account">
          <NoSSR>
            { /* eslint-disable-next-line no-nested-ternary */ }
            { auth.isAuthenticated === null ? null : auth.isAuthenticated ? (
              <div className="header-skeleton__user-info">
                <div className="header-skeleton__user-avatar" />
                <div className="header-skeleton__user-balance" />
              </div>
            ) : (
              <div className="header-login__buttons-container">
                <RegisterLoginButtons
                  openLoginPanel={ () => openDropPanel('loginPanel') }
                  isDesktop={ userAgent.device?.type === 'desktop' }
                  toggleMenu={ toggleMenu }
                />
                { activeDropPanel === 'loginPanel' && (
                  <DropPanelDesktop onClose={ closeDropPanel }>
                    <LoginForm />
                  </DropPanelDesktop>
                ) }
              </div>
            ) }
          </NoSSR>
        </div>
      </div>
    </div>
  );
};

HeaderSkeleton.propTypes = {
  auth: PropTypes.object.isRequired,
  userAgent: PropTypes.object.isRequired,
  openDropPanel: PropTypes.func.isRequired,
  toggleMenu: PropTypes.func.isRequired,
  activeDropPanel: PropTypes.string,
  closeDropPanel: PropTypes.func.isRequired
};

export default HeaderSkeleton;
